import * as Html from "../../util/Html.ts";
import ApiServer from "../../ApiServer.ts";
import * as amplify from "../../util/amplify.ts";
import * as modal from "../../util/modal.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as i18n from "../../i18n.ts";
import {CalListCache} from "../../server/EventStore.ts";
import {askCalendarUrl} from "../../calendar/calendar_modal.ts";
import {MonthDatePicker} from "../../calendar/MonthDatePicker.ts";

import Icons from "../../svg/Icons.ts";

import { MealplannerSettingsCache, updateMealplannerSettings } from "../../mealplanner/mealplannerApi.ts";
import { initPaneRight, openPaneRight } from "../../util/PaneRight.ts";

Html.registerWidget('widget/specific/calendarmenu',{initDom})

ApiServer.types.CalendarGroupBean.prototype.hasExternalCalendar = function(){
  if(this.external && this.external.length){
    return true;
  }
  if(this.googles && this.googles.filter(function(cred){return cred.linked.length>0}).length){
    return true;
  }
  if(this.outlooks && this.outlooks.filter(function(cred){return cred.linked.length>0}).length){
    return true;
  }
  return false;
}
ApiServer.types.CalendarGroupBean.prototype.hasExternalCalendarError = function(){
  if(this.googles && this.googles.filter((cred)=>cred.errorCode && cred.linked.length).length){
    return true;
  }
  if(this.outlooks && this.outlooks.filter((cred)=>cred.errorCode && cred.linked.length).length){
    return true;
  }
  if(this.families.filter((cal)=>cal.errorCode).length){
    return true;
  }
  return false;
}

var node: HTMLElement | null = null;
var lastCallResult: any;
var errorShown = false;
var datePicker: any;

async function widgetRefresh(isInit = false){
  initPaneRight()
  return CalListCache.need().then(function(res){
    import("../../calendar/calendarmenu.mustache").then(function(TPL){
      if (!node) return;
      Html.setHtml(node, TPL, res);
      const userSettings = FwDatas.getSettingsPerFamily() || {};

      const datePickerEl = node.querySelector(".MonthDatePicker") as HTMLElement;
      if (datePickerEl) {
        datePicker = new MonthDatePicker(datePickerEl, {
          showWeek: userSettings.calendarWeekNb,
          isBirthday: false,
          date: isInit || datePicker === undefined ? undefined : datePicker.currentDate,
          onpickdate(date: Date, showYear: boolean){
            amplify.publish("DatePicker", date);
          }
        });
      }
    })
    if(res.hasExternalCalendarError()){
      const errorDot = document.getElementById('calendar-error-dot');
      if (errorDot) {
        errorDot.style.display = '';
      }
    }
    lastCallResult = res;
    handleResult(res,"calendarSelection");
  });
}

async function onCalendarSubscribe(calendarSubscriptionResponseBean){
  modal.closeDomModal();
  CalListCache.invalidate()
  widgetRefresh();

  if(calendarSubscriptionResponseBean.createdMetaId.length>1){
    modal.askAsPromise({
      title:"calendars.addedseveratitle",
      message:"calendars.addedseveralmessage",
      lottie:"images/lottie/anim_verified_check.json",
      button:[
        {title:"actions.continue"}
        ]
      });
  }else{
    if('true'===await modal.askAsPromise({
      title:"calendars.addedtitle",
      message:"calendars.addedmessage",
      lottie:"images/lottie/anim_verified_check.json",
      button:[
        {title:"actions.share", value:"true"},
        {title:"actions.continue",class:"secondary"}
        ]
      })){
        Html.trigger(null,"caledit",[calendarSubscriptionResponseBean.createdMetaId[0]])

      }
  }
}

ApiServer["custom.caledit"]  = async function(form: HTMLFormElement){
  const mpsettings = await MealplannerSettingsCache.need();
  if(mpsettings){
    const timeInputs = form.querySelectorAll<HTMLInputElement>("input[type='time']");
    timeInputs.forEach((input) => {
      if(input.value.length){
        const column = mpsettings.columns.find(c => c.type === input.name);
        if (column) {
          column.timeSlot = input.value;
        }
      }
    });
    await updateMealplannerSettings(mpsettings);
  }
  const mainCalBean = ApiServer.flattenForm(form);
  const subactivateInput = form.querySelectorAll<HTMLInputElement>('input[name=subactivate]');

  if(mainCalBean.useCalendarColor !== undefined){
    mainCalBean.useEventColor = (mainCalBean.useCalendarColor[0] !== 'true')
    delete mainCalBean.useCalendarColor;
  }
  if(subactivateInput.length){
    mainCalBean.activated = false;
    subactivateInput.forEach((input) => {
      ApiServer.evtcalupdate({metaId: input.value, activated: input.checked});
      if(input.checked){
        mainCalBean.activated = true;
      }
    });
  }
  //we must chain every call so do not use direct call with form
  ApiServer.evtcalupdate(mainCalBean);
  modal.closeDomModal();
  CalListCache.refresh().then(callist => {
    import("../../calendar/calendarmenu.mustache").then(function(TPL){
      if (node) {
        Html.setHtml(node, TPL, callist);
      }
    })
    handleResult(callist, "calendarModification");
  })
}

function handleResult(res, amplifyEvent){
  var ids = [],i,j,obj,cred;
  var calInError = null;

  for(i=0;i<res.mine.length;i++){
    obj = res.mine[i];
    if(obj.activated){
      if(obj.calendars){
        obj.calendars.forEach(o=>{if(o.activated){ids.push(o.metaId)}})
      }else{
        ids.push(obj.metaId);
      }
    }
  }
  for(i=0;i<res.families.length;i++){
    obj = res.families[i];
    if(obj.errorCode) calInError = obj;
    if(obj.activated){
      ids.push(obj.metaId);
    }
  }
  for(i=0;i<res.googles.length;i++){
    cred = res.googles[i];
    for(j=0;j<cred.linked.length;j++){
      obj = cred.linked[j];
      if(obj.errorCode) calInError = obj;
      if(obj.activated){
        ids.push(obj.metaId);
      }
    }

  }
  for(i=0;i<res.outlooks.length;i++){
    cred = res.outlooks[i];
    for(j=0;j<cred.linked.length;j++){
      obj = cred.linked[j];
      if(obj.errorCode) calInError = obj;
      if(obj.activated){
        ids.push(obj.metaId);
      }
    }
  }
  if(res.external){
    for(i=0;i<res.external.length;i++){
      obj = res.external[i];
      if(obj.activated){
        ids.push(obj.metaId);
      }
    }
  }
  for(i=0;i<res.timetables.length;i++){
    obj = res.timetables[i];
    if(obj.activated){
      ids.push(obj.metaId);
    }
  }
  for(i=0;i<res.budgets.length;i++){
    obj = res.budgets[i];
    if(obj.activated){
      ids.push(obj.metaId);
    }
  }
  if(!errorShown && calInError){
    errorShown = true;
    modal.toast({
      emoji:'😒',
      text:"calendars.calerror.toast",
      button:[
        {title:"actions.learnmore",onclick:()=>{
          Html.triggerbystring(null,'calediterror|'+calInError.metaId)

          openPaneRight();
          var node = document.querySelector('[data-fw-meta-id="'+calInError.metaId+'"]');
          if(node){
            node.scrollIntoView()
          }

        }}
      ]
    })
  }
  amplify.publish(amplifyEvent,ids);
}

Html.registerDom({
  evtcalactivate(metaId,activated){
    ApiServer.evtcalupdate({metaId:metaId,activated:activated});
    CalListCache.invalidate()
    widgetRefresh();
  },
  async evtcalaskdelete(metaId){
    var doit = await modal.askAsPromise({
      title:'calendars.caldelete.button',
      messageHTML:i18n.get('calendars.caldelete.text',{name:Html.escape(FwDatas.get(metaId).name)}),
      image:"/images/calendar_dialog_subscription_remove.svg",
      button:[{title:"calendars.caldelete.button",class:"negative",value:"true"}]
    })
    if(doit==='true'){
      modal.closeDomModal();
      ApiServer.evtcaldelete(metaId);
      CalListCache.invalidate()
      widgetRefresh().then(calGroup=>{
        modal.toast({text:'calendars.deleted',svg:Icons.ic_done})
      });
    }
  },
  googleeditcredential(credentialId){
    ApiServer.googlegetcredential(credentialId,function(cred){
      import("../../modal/calgoogle_edit.mustache").then(function(TPL){
        modal.openDomModal(TPL,cred);
      });
    });

  },
  googlepick(credentialId,googleId){
    ApiServer.googleselectcalendar2(credentialId,googleId,onCalendarSubscribe);
  },
  googleconnect(){
    ApiServer.googleAuthUri(function(uri){
      window.location = (uri);
    })
  },
  outlookconnect(){
    ApiServer.outlookAuthUri(function(uri){
      window.location = (uri);
    })
  },
  outlookeditcredential(credentialId){
    ApiServer.outlookgetcredential(credentialId,function(cred){
      import("../../modal/caloutlook_edit.mustache").then(function(TPL){
        modal.openDomModal(TPL,cred);
      });
    });
  },
  outlookpick(credentialId,outlookId){
    ApiServer.outlookselectcalendar2(credentialId,outlookId,onCalendarSubscribe);
  },
  async icsconnect(){
    var url = await askCalendarUrl({title:'calendars.icssubscription'})
    if(url){
      ApiServer.evtcalsubscribe2(url,onCalendarSubscribe)
    }
  },

  async calcountrypicker(){
    //prepare proposals
    var proposal : {title:string,emoji:string,calendarIds:string[]}[] = lastCallResult.suggestions.map(calproposal=>{
      var
        name = i18n.getCountry(calproposal.countryCode,calproposal.countryLang),
        codePoints = calproposal.countryCode
          .toUpperCase()
          .split('')
          .map(char =>  127397 + char.charCodeAt()),
        emoji = String.fromCodePoint(...codePoints);

      return {title:name,emoji:emoji,calendarIds:calproposal.calendarIds};
    })
    proposal.sort((a,b)=>{
      return a.title.localeCompare(b.title)
    })

    //propose
    var button = await modal.pick({
      title:'calendars.pickcountry',
      gap:"var(--space-xs)",
      button:proposal
    })
    //handle picked proposition
    if(button!==null){
      var
        metaIds = button.calendarIds,
        calendarGroupBean = await CalListCache.need(),
        alreadyCount = calendarGroupBean.mine.filter(cal=>metaIds.indexOf(cal.metaId)>-1).length;
      if(alreadyCount==metaIds.length){
        modal.toast({text:'calendars.countryalreadyadded',emoji:'🤔'})
        return;
      }
      metaIds.forEach(metaId=>{
        ApiServer.evtcalupdate({metaId:metaId,activated:true});
      })
      modal.closeDomModal();
      CalListCache.invalidate()
      await widgetRefresh()
      modal.toast({text:'calendars.countryadded',emoji:'🎉'})

    }
  }

})

ApiServer["custom.outlookselectcalendar"] = function(form: HTMLFormElement, onsuccess: any, onerror: any){
  const checkedInputs = document.querySelectorAll<HTMLInputElement>('input[name="outlookId"]:checked');
  const value = Array.from(checkedInputs).map(t => t.value);
  if(value.length === 0){
    modal.alert('calendars.mustpick');
  }else{
    ApiServer.outlookselectcalendar2(form.credentialId.value, value, onCalendarSubscribe, onerror)
  }
};

ApiServer["custom.googleselectcalendar"] = function(form: HTMLFormElement, onsuccess: any, onerror: any){
  const checkedInputs = document.querySelectorAll<HTMLInputElement>('input[name="googleId"]:checked');
  const value = Array.from(checkedInputs).map(t => t.value);
  if(value.length === 0){
    modal.alert('calendars.mustpick');
  }else{
    ApiServer.googleselectcalendar2(form.credentialId.value, value, onCalendarSubscribe, onerror)
  }
};

export function initDom(obj: HTMLElement){
  node = obj;
  widgetRefresh(true);
}